
import { Placement } from '@post-office/placements-frontend/townsquare-onboarding-widget';
export default Placement;
